import '../../CommonStyles.scss';
import Chart from 'chart.js/auto';
import { CategoryScale } from 'chart.js';
import { useGetWebinarsSummary } from 'queryHooks/analytics';
import { Bar } from 'react-chartjs-2';
import Paper from '@trackman/web-shared-components/components/Paper/Paper';
import { getLatestDayData } from 'utilities/getLatestDayData';
import { createEndValuePlugin } from 'utilities/chartEndValue';
import { options } from '../../consts/barChartConfig';
import { SourceBadge } from '../SourceBadge/SourceBadge';

Chart.register(CategoryScale);

export const ViewsPerWebinarChartCard = () => {
  return (
    <Paper className='analytics-card'>
      <div className='analytics-card__title-group'>
        <span className='card-title'>Views per webinar</span>
        <SourceBadge source='YOUTUBE' />
      </div>
      <ViewsPerWebinarChart />
    </Paper>
  );
};

const ViewsPerWebinarChart = () => {
  const NUMBER_OF_ENTRIES = 10;
  const endValuePlugin = createEndValuePlugin({
    textAlign: 'center',
    offsetX: -25,
    color: '#fff',
    formatter: (value) => value.toLocaleString('en-US'),
  });

  const { data: webinarsSummary } = useGetWebinarsSummary();
  const latestDayData = getLatestDayData(webinarsSummary || [], 'date');

  const sortedChartEntries = latestDayData?.sort((a, b) => b.views - a.views).slice(0, NUMBER_OF_ENTRIES);

  const labels = sortedChartEntries?.map((entry) => entry.title) ?? [];
  const chartDataset = {
    labels,
    datasets: [
      {
        data: sortedChartEntries?.map((entry) => entry.views) ?? [],
        backgroundColor: 'rgba(236, 105, 26, 0.7)',
        barThickness: 17,
      },
    ],
  };

  return (
    <div style={{ height: '260px' }}>
      <Bar data={chartDataset} options={options} plugins={[endValuePlugin]} />
    </div>
  );
};
